
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":"5.059","width":"16","height":"1.882","rx":".941","fill":"#282E3E"}}),_c('rect',{attrs:{"width":"16","height":"1.882","rx":".941","fill":"#282E3E"}}),_c('rect',{attrs:{"y":"10.118","width":"16","height":"1.882","rx":".941","fill":"#282E3E"}})])
          )
        }
      }
    